var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link mao",attrs:{"href":"/"},on:{"click":_vm.logout}},[_c('i',{staticClass:"fas fa-sign-out-alt"}),_c('span',[_vm._v(" "+_vm._s(_vm.logoutTranslation || 'Logout'))])])}
var staticRenderFns = []

export { render, staticRenderFns }